import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import React from "react";
import FavouriteButton from "src/storefront/components/favourite_button";
import { storeStorefrontFavouritesPath } from "src/routes";

export default class extends Controller {
  static values = {
    favourited: Boolean,
    storeId: String,
  }

  declare favouritedValue: boolean;
  declare storeIdValue: string;

  csrfToken!: string;

  connect() {
    this.csrfToken = (document.querySelector("meta[name='csrf-token']") as HTMLMetaElement)?.content ?? "";

    const root = createRoot(this.element);
    root.render(React.createElement(FavouriteButton, {
      isFavourite: this.favouritedValue,
      onFavouriteChange: (isFavourite: boolean) => this.updateFavourite(isFavourite),
    }));
  }

  private async updateFavourite(isFavourite: boolean): Promise<boolean> {
    const response = await fetch(storeStorefrontFavouritesPath(this.storeIdValue, { format: 'json' }), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken,
      },
      body: JSON.stringify({ favourite: isFavourite }),
    });

    if (response.status == 200) {
      return isFavourite;
    } else {
      return !isFavourite;
    }
  }
}
